import { useContext } from 'react';
import { UserContext } from '@/contexts/UserContext';
import { useClientUser } from '@/hooks/useClientUser';

/**
 * The ID that owns saved export templates for this session. It is the client's `client_id` when
 * there is one (including an Onward admin impersonating a client), otherwise the signed-in login's
 * `user_id` for an admin in the combined view. Any other login with no client yet (a teammate whose
 * team leader's client is still loading) gets `undefined`, because its `user_id` is not the ID the
 * templates are stored under. `undefined` while loading or signed out.
 *
 * Use this for every `csv_export_templates` read and write. `useClientUser().user_id` is a tenancy
 * filter and is `undefined` for a corporate admin.
 *
 * @returns {string | undefined}
 */
export const useExportTemplateOwnerId = () => {
    const { user } = useContext(UserContext);
    const { client_id } = useClientUser();

    if (client_id) return client_id;

    const isAdmin = !!user?.roles?.['ADMIN'] || !!user?.roles?.['ONWARD_ADMIN'];
    return isAdmin ? user.user_id : undefined;
};
